module.exports = __webpack_public_path__ + "img/top.67ed05a8.png";